angular.module('unica_media_moderation.media_services')

.factory('MediaModerationDeleteService', function ($http, getBaseApiURL) {

	var mediaDeleteService = {};

	mediaDeleteService.delete = function (mediaId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/media-moderation/delete/' + mediaId,
			data: {	}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return mediaDeleteService;
});